import script from "./NewsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsSection.vue?vue&type=script&setup=true&lang=ts"

import "./NewsSection.vue?vue&type=style&index=0&id=44a367d0&lang=scss"

const __exports__ = script;

export default __exports__